import { Grid as MuiGrid, Stack as MuiStack } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { formatEther } from "viem";

import type { IToken, IUser } from "@framework/types";
import { StyledCardMedia } from "@framework/styled";
import { Card, Typography } from "@dzambalaorg/ui-kit";
import { useUser } from "@dzambalaorg/provider-user";

import { Erc20AddToMetamaskButton } from "../../../../../components/buttons";
import { Erc20CoinInfo } from "./Erc20CoinInfo";

interface IErc20TokenListItemProps {
  token: IToken;
}

export const Erc20CoinsListItem = (props: IErc20TokenListItemProps) => {
  const { token } = props;
  const user = useUser<IUser>();
  const wallet = user.profile.wallet;

  const tokenBalance = token.balance?.filter(b => b.account === wallet);

  return (
    <Card
      header={
        <Card.Header
          action={<Erc20CoinInfo token={token} />}
          title={<StyledCardMedia image={token.template!.imageUrl} />}
          subheader={<Typography variant="h5">{token.template!.title}</Typography>}
        />
      }
    >
      <Card.Content>
        {token.template?.contract && (
          <MuiStack direction="row" gap={2} mb={1}>
            <Typography variant="numeric">
              <FormattedMessage id="pages.token.symbol" />
            </Typography>
            <Typography variant="numeric">{token.template.contract?.symbol}</Typography>
          </MuiStack>
        )}
        {tokenBalance && (
          <MuiStack direction="row" gap={2}>
            <Typography variant="numeric">
              <FormattedMessage id="pages.token.balanceTitle" />
            </Typography>
            <Typography variant="numeric">
              {tokenBalance.length ? formatEther(BigInt(tokenBalance[0].amount)) : 0}
            </Typography>
          </MuiStack>
        )}
      </Card.Content>
      <Card.Footer>
        <MuiGrid container alignItems="center">
          <MuiGrid size={{ xs: 12 }}>
            <Erc20AddToMetamaskButton token={token} />
          </MuiGrid>
        </MuiGrid>
      </Card.Footer>
    </Card>
  );
};
